import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { BookingStates } from '../../../../../../constants/booking-states';
import { BookingSummaryItem } from '../../../common/items/BookingSummaryItem';
import { checkIsGuestView } from '../../../common/utils/check-is-guest-view';
import { BookingPriceCalculator } from './BookingPriceCalculator';

const getContractCalcLabel = (offerPending, isGuestView) => {
  if (isGuestView) {
    return (
      <FormattedMessage
        id='inbox.summary_props.price_contract'
        defaultMessage='Price'
      />
    );
  }

  const label = offerPending ? (
    <FormattedMessage
      id='inbox.summary_props.estimated_payout_contract'
      defaultMessage='Estimated Payout'
    />
  ) : (
    <FormattedMessage
      id='inbox.summary_props.your_payout_contract'
      defaultMessage='Your Payout'
    />
  );
  return label;
};

const showPendingContracts = (pendingContracts) => {
  if (isEmpty(pendingContracts)) {
    return false;
  }
  const pendingMaster = pendingContracts.find((c) => c.type === 'MASTER');
  return pendingMaster?.state !== BookingStates.GUEST_UPDATE_NO_AUTH;
};

export const BookingSummaryPrice = ({
  currentBooking,
  currentContracts,
  pendingContracts,
  profile
}) => {
  const isGuestView = checkIsGuestView(profile, currentBooking);
  const prices = currentBooking.listing?.prices || [];
  const currency = prices[0]?.currency || currentBooking.list_price?.currency;
  const offerPending = [
    BookingStates.OFFER_SUBMITTED,
    BookingStates.HOST_UPDATE_REQUESTED,
    BookingStates.GUEST_UPDATE_REQUESTED
  ].includes(currentBooking.obj_state);

  return (
    <BookingSummaryItem
      testingId='booking-summary-price'
      label={getContractCalcLabel(offerPending, isGuestView)}
    >
      <BookingPriceCalculator
        contracts={
          showPendingContracts(pendingContracts)
            ? pendingContracts
            : currentContracts
        }
        profile={profile}
        offerPending={offerPending}
        currency={currency}
        isGuestView={isGuestView}
      />
    </BookingSummaryItem>
  );
};

BookingSummaryPrice.propTypes = {
  currentBooking: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  currentContracts: PropTypes.arrayOf(PropTypes.object).isRequired,
  pendingContracts: PropTypes.arrayOf(PropTypes.object)
};
